module.exports = __webpack_public_path__ + "img/hero-dog.caf4fe27.png";